const privateAxios = (axiosInstance) => {
  axiosInstance.interceptors.request.use(
    function (request) {
      const decryptToken = localStorage.getItem("accessToken");
      if (decryptToken) {
        request.headers = {
          ...request.headers,
          Authorization: `Bearer ${decryptToken}`,
          // 'Access-Control-Allow-Origin': '*',
        };
      }
      return request;
    },
    async function (error) {
      return Promise.reject(error);
    }
  );

  axiosInstance.interceptors.response.use(
    async function (successRes) {
      return successRes;
    },
    async function (error) {
      const { response } = error;
      if (response) {
        if (
          // response.data.status === 500 ||
          // response.data.status === 404 ||
          // response.data.status === 403 ||
          response.data.status === 401
        ) {
          window.localStorage.clear();
          window.sessionStorage.clear();
          window.location.href = "/login";
        }
      }
      return Promise.reject(error);
    }
  );
  return axiosInstance;
};
export default privateAxios;
